export class GroupSummary {
  totalManifest = 0;
  totalStt = 0;

  constructor(fields?: Partial<GroupSummary>) {
    Object.assign(this, fields);
  }
}

export class Stt {
  no = 0;
  noManifest = "";
  bagNo = "";
  sttNo = "";
  isAggregator = false;
  productType = "";
  hangingDays = 0;
  destination = "";
  existenceStatus = "";
  existenceLocation = "";
  existenceLocationNote = "";
  existenceUsername = "";
  existenceFindAt = "";
  isChecked = false;

  constructor(fields?: Partial<Stt>) {
    Object.assign(this, fields);
  }
}

export class Group {
  groupName = "";
  summary: GroupSummary = new GroupSummary();
  stts: Stt[] = [];
  isChecked = false;

  constructor(fields?: Partial<Group>) {
    Object.assign(this, fields);
  }
}

export class FollowUp {
  courierName = "";
  courierPhone = "";
  opsUsername = "";
  username = "";
  partnerType = "";
  partnerCode = "";
  partnerName = "";


  constructor(fields?: Partial<FollowUp>) {
    Object.assign(this, fields);
  }
}

export class CardHangingShared {
  activityId = 0;
  activityType = "";
  followUpStatus = "";
  followUp: FollowUp = new FollowUp();
  groups: Group[] = [];
  isCollapsed = false;
  followUpById = 0;
  followUpByUsername = "";
  followUpAt = "";

  constructor(fields?: Partial<CardHangingShared>) {
    Object.assign(this, fields);
  }
}
